<template>
  <content-row :not-openable="true">

    <!--------------------- MAIN --------------------->
    <div slot="main">
      <div v-bind:class="classObject">
        <span class="title-item">PRÉNOM</span>
        <input class="form-control input-edit" type="text" v-model="person.firstname"/>
        <div class="error-message">
          {{ this.firstNameValidationMessage }}
        </div>
      </div>
      <div v-bind:class="classObject">
        <span class="title-item">NOM</span>
        <input class="form-control input-edit" type="text" v-model="person.lastname"/>
        <div class="error-message">
          {{ this.lastNameValidationMessage }}
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <span class="title-item">LOGIN</span>
        <input class="form-control input-edit" type="text" v-model="person.login"/>
        <div class="error-message">
          {{ this.loginValidationMessage }}
        </div>
      </div>
      <div class="col-sm-6 col-md-3" v-if="!showProfilDiv">
        <span class="title-item">EMAIL</span>
        <input class="form-control input-edit" type="text" v-model="person.email"/>
        <div class="error-message">
          {{ this.emailValidationMessage }}
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <span class="title-item">MOT DE PASSE</span>
        <input
          type="password"
          class="form-control"
          id="password"
          v-model="person.password"
        />
        <div class="error-message">
          {{ this.passwordValidationMessage }}
        </div>
      </div>
      <div class="col-sm-6 col-md-2" v-if="showProfilDiv">
        <span class="title-item">PROFIL</span>
        <input type="radio" id="expert" value="Expert" v-model="person.profile">
        <label for="expert">Expert</label>
        <br>
        <input type="radio" id="novice" value="Novice" v-model="person.profile">
        <label for="novice">Novice</label>
      </div>
    </div>

    <!--------------------- BOTTOM_ACTIONS --------------------->
    <div slot="bottom-actions">
      <button class="btn btn-secondary" @click="cancel()">
        Annuler
      </button>
      <button class="btn btn-primary" @click="create()">
        Créer
      </button>
    </div>

  </content-row>
</template>

<script>
import ContentRow from './ContentRow'
import {mapState} from 'vuex'

export default {
  computed: {
    createAgent: function () {
      return this.$store.getters.createAgent
    },
    classObject: function () {
      return {
        'col-sm-6 col-md-3': this.$store.getters.getShowProfilDiv,
        'col-sm-4 col-md-2': !this.$store.getters.getShowProfilDiv,
      }
    },
    ...mapState([
      'showProfilDiv',
    ]),
  },
  components: {
    ContentRow,
  },
  data: function () {
    return {
      person: {
        firstname: '',
        lastname: '',
        login: '',
        email: '',
        password: '',
        profile: 'Expert',
      },
      firstNameValidationMessage: '',
      lastNameValidationMessage: '',
      loginValidationMessage: '',
      passwordValidationMessage: '',
      emailValidationMessage: '',
    }
  },
  methods: {
    cancel: function () {
      this.$emit('close')
    },
    create: function () {
      if (this.validateFirstName() && this.validateLastName() && this.validateLogin() && this.validateEmail() && this.validatePassword()) {
        this.$emit('confirm', this.person)
      }
    },
    getShowProfilDiv: function () {
      this.$store.showProfilDiv
    },
    validatePassword () {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/

      if (!passwordRegex.test(this.person.password)) {
        this.passwordValidationMessage =
          'Le mot de passe doit contenir au moins 8 caractères, dont une lettre minuscule, une lettre majuscule, un chiffre et un caractère spécial (@$!%*?&).'
        return false
      } else {
        this.passwordValidationMessage = ''
        return true
      }
    },
    validateFirstName () {
      console.log('this.person.firstname ::: ', this.person.firstname)
      if (this.person.firstname.trim() === '') {
        console.log('error first name ')
        this.firstNameValidationMessage =
          'Le prénom ne doit pas être vide.'
        return false
      } else {
        this.firstNameValidationMessage = ''
        return true
      }
    },
    validateLastName () {
      if (this.person.lastname.trim() === '') {
        this.lastNameValidationMessage =
          'Le nom ne doit pas être vide.'
        return false
      } else {
        this.lastNameValidationMessage = ''
        return true
      }
    },
    validateLogin () {
      if (this.person.login.trim().length < 6) {
        this.loginValidationMessage =
          'Le login doit contenir au moins 6 caractères.'
        return false
      } else {
        this.loginValidationMessage = ''
        return true
      }
    },
    validateEmail () {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (this.showProfilDiv) {
        return true
      }
      if (!emailRegex.test(this.person.email)) {
        this.emailValidationMessage =
          'Vous devez renseigner une adresse email valide.'
        return false
      } else {
        this.emailValidationMessage = ''
        return true
      }
    }
  },
}
</script>

<style lang="scss">
@import "../../scss/variables";
@import "../../scss/mixins/input-edit-suez";

#person-create {
  .action-card {
    background-color: #F3F3F3;
    padding: 1rem;
    text-align: right;
  }

  .information-card {
    background-color: $suez-white;
    padding: 1% 0 2% 0;

    .row-spacing {
      margin-top: 1.5%;
    }

    .input-edit {

    }
  }
}
.error-message {
  color: red;
}
</style>



// WEBPACK FOOTER //
// PersonCreate.vue?71a63e96